/**
 * TanStack Query hooks for `fraud-alert-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fraudAlertWidgetQueryKeys,
	type CreateFraudAlertWidgetBody,
	type ListFraudAlertWidgetResponse,
	type FraudAlertWidgetRow,
} from "./api";

export function useFraudAlertWidgetList(): UseQueryResult<ListFraudAlertWidgetResponse, Error> {
	return useQuery({
		queryKey: fraudAlertWidgetQueryKeys.list(),
		queryFn: list,
	});
}

export function useFraudAlertWidgetCreate(): UseMutationResult<FraudAlertWidgetRow, Error, CreateFraudAlertWidgetBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudAlertWidgetQueryKeys.all });
		},
	});
}

export function useFraudAlertWidgetDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudAlertWidgetQueryKeys.all });
		},
	});
}
